import React, {Component} from "react";


import "./organization-card.css";

class OrganizationCard extends Component {

    onClick() {
        let {on_click, organization} = this.props;
        on_click(organization);
    }

    render() {

        let {organization, is_current} = this.props;


        let styleClass = "manager_dashboard_organization";
        if (is_current) {
            styleClass += " current";
        }

        return (
            <div className={styleClass} organization_id={organization.id} onClick={this.onClick.bind(this)}>{organization.name}</div>
        );
    }
}


export default OrganizationCard;



// WEBPACK FOOTER //
// ./src/components/containers/manager-dashboard/manage-personnel/organization-card.js